export default "__VITE_ASSET__DBgGcOdL__"